// extracted by mini-css-extract-plugin
export default {"containerSong":"cardVideo_containerSong__Tu5Si","titlePostText":"cardVideo_titlePostText__84sXf"};